import React from "react";
import { FC, Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Button,
    Modal,
} from "semantic-ui-react";
import '../css/SessionNotStartedModal.css'
import Boschicon from "../../../common-components/boschIcon/Boschicon";

const SessionNotStartedModal: FC<any> = (props: any) => {
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const { t } = useTranslation();

    useEffect(() => {
        if (props.showError && props.errorMessage != null && props.errorMessage != '') {
            setErrorMessage(props.errorMessage);
            setOpenErrorModal(true);
        }
        else {
            setErrorMessage('');
        }
    }, [props]);


    const closeErrorModal = () => {
        setErrorMessage('');
        setOpenErrorModal(false);
        props.onSetErrorTrigger();
    }

    return (
        <Fragment>
            <Modal
                open={openErrorModal}
                size={"mini"}>
                <div className="errorModal">
                    <div className="colorBar">

                    </div>
                    <div className="error-area">
                        <div className="error--title">
                            <Boschicon name={'alert-info'} />
                            <p>
                                {errorMessage}
                            </p>
                        </div>
                        <div className="error--content">
                            <p>{t('Retry_note')}</p>
                        </div>
                        <div className="btn--option">
                            <Button onClick={closeErrorModal} primary color='blue'>
                                {t('Retry_panel')}</Button>
                        </div>
                    </div>

                </div>
            </Modal>
        </Fragment>
    )
}

export default SessionNotStartedModal;